import React from "react";
import ModalV2 from "../modalV2";
import { SUCCESS } from "../../../assets";

function SuccessModal({
  open,
  close,
  message,
}: {
  open: boolean;
  close: () => void;
  message: string;
}) {
  return (
    <ModalV2
      isOpen={open}
      isClose={close}
      maxWidth="w-[430px]"
      edges="rounded-xl"
    >
      <div className="px-12 py-10 flex flex-col w-full items-center justify-center gap-y-3">
        <img src={SUCCESS} className="w-[92px] h-[92px]" alt="" />
        <span className="text-[20px] font-semibold">{message}</span>

        <button
          onClick={close}
          className="bg-[#009444] w-full text-white px-10 py-3 rounded-xl"
        >
          Close
        </button>
      </div>
    </ModalV2>
  );
}

export default SuccessModal;
